import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
interface UpdatePayoutStatusDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  updateTo: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const UpdatePayoutStatusDialog: React.FC<UpdatePayoutStatusDialogProps> = ({
  confirmButtonState,
  open,
  updateTo,
  onConfirm,
  onClose
}) => {
  let title: string;
  let message;
  let variant;

  switch (updateTo) {
    case "ON_PROCESS":
      title = "Submit for Review";
      message = "Are you sure to submit this payout?";
      variant = "default";
      break;
    case "FOR_PAYMENT":
      title = "Approve Payout";
      message = "Are you sure to approve this payout?";
      variant = "default";
      break;
    case "PAYMENT_PROCESSING":
      title = "Approve Payout";
      message = "Are you sure to approve this payout?";
      variant = "default";
      break;
    case "READY_FOR_PAYMENT":
      title = "Approve Payout";
      message = "Are you sure to approve this payout?";
      variant = "default";
      break;
    case "COMPLETED":
      title = "Complete Payout";
      message = "Are you sure to complete this payout?";
      variant = "default";
      break;
    case "RETURNED":
      title = "Return Payout";
      message = "Are you sure to return this payout?";
      variant = "default";
      break;
    default:
      title = "";
      message = "";
      variant = "info";
      break;
  }

  return (
    <ActionDialog
      open={open}
      confirmButtonState={confirmButtonState}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      variant={variant}
      confirmButtonLabel="YES"
    >
      <DialogContentText>{message}</DialogContentText>
    </ActionDialog>
  );
};

export default UpdatePayoutStatusDialog;
